import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalOptions } from '../models/modal-options';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  @Input() options: ModalOptions = new ModalOptions();
  @Input() contentTemplate!: TemplateRef<any>;

  currentTemplate!: TemplateRef<any>;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.currentTemplate = this.contentTemplate;
  }

  public save() {
    this.activeModal.close('Save Clicked');
  }

  public cancel(reason: string) {
    this.activeModal.dismiss(reason);
  }

}


